import { useTranslation } from '../i18n';
import React from 'react';
import { Tag } from 'antd';
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    PauseCircleOutlined,
    StopOutlined
} from '@ant-design/icons';

/**
 * CDN 域名状态标签（共享）
 *
 * 统一 admin / user 两端对 CDN 域名 status 字段的颜色/图标/文案，覆盖完整状态集，
 * 避免各端 statusConfig 键集合不重叠导致的错误 fallback（如 suspended 被显示成「未完成」）。
 */
export const CDN_DOMAIN_STATUS_MAP = {
    active: { color: 'success', icon: <CheckCircleOutlined />, text: '活跃' },
    pending: { color: 'warning', icon: <ClockCircleOutlined />, text: '未完成' },
    processing: { color: 'processing', icon: <ClockCircleOutlined />, text: '处理中' },
    inactive: { color: 'default', icon: <CloseCircleOutlined />, text: '未激活' },
    suspended: { color: 'warning', icon: <PauseCircleOutlined />, text: '已暂停' },
    terminated: { color: 'error', icon: <StopOutlined />, text: '已终止' }
};

const CdnDomainStatusTag = ({ status }) => {
    const { t } = useTranslation();
    const config = CDN_DOMAIN_STATUS_MAP[status]
        || { color: 'default', icon: <CloseCircleOutlined />, text: status || t('Unknown') };
    return <Tag icon={config.icon} color={config.color}>{t(config.text)}</Tag>;
};

export default CdnDomainStatusTag;
